// Ensure the global object exists
window.TelegramGameProxy = window.TelegramGameProxy || {};

// Store the original function if it exists
const originalReceiveEvent = window.TelegramGameProxy.receiveEvent;

// Initialize the function if it's not already defined
if (!originalReceiveEvent) {
  window.TelegramGameProxy.receiveEvent = (...args: any[]) => {
    if (typeof originalReceiveEvent === 'function') {
      // Call the original implementation
      return originalReceiveEvent(...args);
    } else {
      // Otherwise, log and ignore the event
      console.debug('[TelegramGameProxy.receiveEvent] Ignored:', ...args);
      return undefined;
    }
  };
}
